// «К разбору» справочника (005: FR-009, FR-034, FR-034а; макет 5): счётчик у пункта меню
// «Справочник» и панели «Главной» берут один ответ directory.triage. Меню опрашивает его в фоне
// раз в минуту с X-KP-Background — сеанс опрос не продлевает (FR-008б 001), как счётчик
// «Оповещений». Ключ кэша общий: «Главная» показывает то же число, что меню.
import { apiQuery } from '../api/client.ts';

export function triageQuery() {
  return {
    ...apiQuery('directory.triage', { background: true }),
    refetchInterval: 60_000,
    staleTime: 30_000,
  };
}
